import useTestId from '@ori/testid-generator';
import times from 'lodash.times';
import { Fragment, type FC } from 'react';

import { CHIP_HEIGHT } from '../SearchPreview/components';
import { Root, Inner, Products, StyledDivider, Suggestions } from '../SearchPreview/styles';
import { UnifiedSkeleton } from '../styles';
import { SEARCH_PREVIEW_PRODUCT_SKELETON, SearchPreviewProductSkeleton } from './components';
import {
  PRODUCTS_COUNT,
  SEARCH_PREVIEW_SKELETON,
  SEARCH_PREVIEW_SKELETON_HEADER,
  SEARCH_PREVIEW_SKELETON_SUGGESTION,
  SUGGESTIONS_COUNT,
} from './constants';
import { HeaderSkeleton, SeeAllSkeleton } from './styles';
import { type SearchPreviewSkeletonProps } from './types';

export const SearchPreviewSkeleton: FC<SearchPreviewSkeletonProps> = ({ animation = 'pulse', className }) => {
  const { getTestId } = useTestId();

  return (
    <Root
      data-testid={getTestId(SEARCH_PREVIEW_SKELETON)}
      className={className}
    >
      <Inner>
        <Suggestions>
          {times(SUGGESTIONS_COUNT, (index) => (
            <UnifiedSkeleton
              key={`${SEARCH_PREVIEW_SKELETON_SUGGESTION}-${index}`}
              data-testid={getTestId(SEARCH_PREVIEW_SKELETON_SUGGESTION)}
              animation={animation}
              width={100}
              height={CHIP_HEIGHT}
            />
          ))}
        </Suggestions>
        <HeaderSkeleton
          data-testid={getTestId(SEARCH_PREVIEW_SKELETON_HEADER)}
          animation={animation}
          variant="text"
        />
        <Products>
          {times(PRODUCTS_COUNT, (index) => (
            <Fragment key={`${SEARCH_PREVIEW_PRODUCT_SKELETON}-${index}`}>
              <SearchPreviewProductSkeleton animation={animation} />
              {PRODUCTS_COUNT - 1 === index ? null : <StyledDivider />}
            </Fragment>
          ))}
        </Products>
      </Inner>
      <SeeAllSkeleton />
    </Root>
  );
};
